import { ReactNode } from "react";
import { AuthHeader } from "./AuthHeader";
import classNames from "classnames";
import { useWindowSize } from "hooks/useWindowSize";
import { MobileSigninAuthWrapper } from "./MobileSigninAuthWrapper";
import { CompanyListFlow } from "./Testimonial/CompanyListFlow";
import { Testimonial } from "./Testimonial/Testimonial";

export const AuthUIWrapper = ({
  isSignin,
  children,
  buttonBar,
  className,
  isPhoneVerify,
  buttonBarClassName,
  hideMobileFooter,
}: {
  isSignin?: boolean;
  children: ReactNode;
  buttonBar?: ReactNode;
  className?: string;
  isPhoneVerify?: boolean;
  buttonBarClassName?: string;
  hideMobileFooter?: boolean;
}) => {
  const { width, isMobile } = useWindowSize();

  if (isMobile && isSignin) {
    return <MobileSigninAuthWrapper children={children} />;
  }

  return (
    <div className="t-h-screen t-w-screen t-flex t-overflow-hidden">
      <div className="t-flex-1 t-flex t-flex-col t-overflow-hidden t-w-7/12 sm:t-w-full">
        <div className="t-pt-20 t-px-[8.33%] t-pr-32 sm:t-pt-9 sm:t-px-6 t-flex t-flex-col t-flex-1 t-overflow-hidden">
          <div className="t-flex-shrink-0 t-mb-2">
            <AuthHeader />
          </div>
          <div
            className={classNames(
              "t-flex-1 t-min-h-0 t-flex t-flex-col t-pr-[14.3%] sm:t-pr-0",
              {
                [className || ""]: Boolean(className),
              }
            )}
          >
            {children}
            {isMobile && buttonBar && !isSignin && (
              <div
                className={classNames(
                  "t-flex-shrink-0 t-pt-4 t-pb-16 sm:t-pb-6 t-pr-[14.3%] sm:t-pr-0",
                  {
                    [buttonBarClassName || ""]: Boolean(buttonBarClassName),
                  }
                )}
              >
                {buttonBar}
              </div>
            )}
            {isMobile && !hideMobileFooter && (
              <div
                className={classNames(
                  "t-flex t-flex-col t-gap-6 t-bg-surface t-mb-24",
                  {
                    "t-mt-14": !isPhoneVerify,
                    "t-mt-1": isPhoneVerify,
                  }
                )}
              >
                <div className="t-mx-8 t-text-center t-text-subtext-sm t-text-neutral-30">
                  Used by 500+ US startups to stay compliant, including over 5%
                  of YC companies.
                </div>
                <CompanyListFlow />
              </div>
            )}
          </div>
          {!isMobile && buttonBar && !isSignin && (
            <div
              className={classNames(
                "t-flex-shrink-0 t-pt-2 t-pb-16 sm:t-pb-6 t-pr-[14.3%] sm:t-pr-0",
                {
                  [buttonBarClassName || ""]: Boolean(buttonBarClassName),
                }
              )}
            >
              {buttonBar}
            </div>
          )}
        </div>
      </div>
      <Testimonial isSignin={isSignin} />
    </div>
  );
};
